import React from "react";
import WarningIcon from "@material-ui/icons/WarningTwoTone";
import { navigateTo } from "utils/urlUtils";
import { app_route_keys } from "constants/urlPaths";
import { DISPUTE_STATUS_ENUM } from "../../DisputeHistory/constants/disputes.constant";

export const DisputesWarningBanner = () => {
  const handleClick = () => {
    navigateTo(app_route_keys.disputes, {
      // this is the coversion to browser friendly string from normal string
      args: encodeURIComponent(
        JSON.stringify({
          status: DISPUTE_STATUS_ENUM.RAISED,
        })
      ),
    });
  };

  return (
    <div
      className={
        "tw-flex tw-bg-[rgba(255,170,0,1)] tw-text-black tw-items-center"
      }
      onClick={handleClick}
    >
      <div
        className={
          "tw-flex tw-m-auto tw-p-2 tw-justify-center tw-cursor-pointer tw-items-center"
        }
      >
        <WarningIcon className={"tw-text-[24px] tw-mr-2"} />
        <span>
          One or more active disputes are associated with your account and
          require review.
        </span>
      </div>
    </div>
  );
};
